import { CircularProgress, Box } from '@mui/material';
import client from '@api/client';
import { readyPromise } from '@src/media';
import React, { useEffect, useState } from 'react';

export const AppLoader: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const init = async () => {
            try {
                await client.login();
                console.log('AppLoader: client logged in', client.actor);
                
                await readyPromise;
                console.log('AppLoader: media providers ready');
            } catch (e) {
                console.error('AppLoader: init failed', e);
            } finally {
                setIsLoading(false);
            }
        };
        init();
    }, []);

    if (isLoading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', width: '100vw' }}>
                <CircularProgress />
            </Box>
        );
    }

    return <>{children}</>;
};
